<template>
  <div class="index">
    <div class="index__logo-animated left logo-fade delay-two"></div>
    <div class="index__logo-animated bottom logo-fade"></div>
    <div class="index__logo-animated top logo-fade delay-one"></div>
    <div class="index__banner">
      <h1 class="index__banner-title app-title with-bar">Hermes</h1>
      <p class="index__banner-text">Bem-vindo ao Hermes, sua recepção virtual!</p>
    </div>

    <div class="index__login-panel">
      <AppLogoSmall class="index__login-logo" />
      <form @submit.prevent="handleSubmit" id="form-login" class="index__login-form">
        <h4 class="index__login-title app-title with-bar">Login</h4>
        <input
          name="email"
          v-model="user.username"
          type="text"
          id="index__login-username"
          class="index__login-username"
          placeholder="Type your e-mail or user here"
        />
        <input
          name="senha"
          v-model="user.password"
          type="password"
          id="index__login-password"
          class="index__login-password"
          placeholder="Password.."
        />
        <div class="error-section" v-show="showErrors">
          <p
            class="error-msg"
            v-for="(error,index) in inputError"
            :key="index"
          >{{Object.keys(error) | adjustName}} : Inválido</p>
        </div>
        <div class="index__login-bottom">
          <a href="#" class="index__login-recover-pw">Esqueci minha senha.</a>
          <button
            @click.prevent="handleSubmit"
            class="index__login-submit btn has-icon submit-btn"
            :disabled="isLoading"
          >
            Entrar
            <button class="btn-icon">
              <i class="fas fa-arrow-right"></i>
            </button>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { setTimeout } from "timers";
import { validator } from "../mixins";
import AuthService from "../services/AuthService";

const {
  required,
  minLength,
  or,
  alphaNum,
  email
} = require("vuelidate/lib/validators");
export default {
  mixins: [validator],
  data() {
    return {
      user: {
        username: "",
        password: ""
      },
      showErrors: false,
      authService: new AuthService(),
      isLoading: false,
    };
  },
  computed: {
    inputError() {
      let errorArray = [];
      let obj = this.$v.user;

      this.$v.user.username.$invalid
        ? errorArray.push({ username: this.$v.user.username.$params })
        : "";
      this.$v.user.password.$invalid
        ? errorArray.push({ password: this.$v.user.password.$params })
        : "";

      return errorArray;
    }
  },
  mounted() {
    this.$nextTick(function() {
      document.getElementById("index__login-username").focus();
    });
  },
  methods: {
    saveInfoUser(data) {
      this.$store.commit("SaveInfoUser", data);
    },
    setMasterUser(isMaster) {
      this.$store.commit("AuthorityMasterUser", isMaster);
    },
    connectSocket() {
      this.$socket.connect();
    },
    authMasterUser(data) {
      this.setMasterUser(true);
      this.saveInfoUser(data);
      this.$router.push("/company/home");
    },
    authUser(data) {
      this.$router.push("/company/context/home");
      this.setMasterUser(false);
      this.saveInfoUser(data);
    },
    setMainCompany(companyId) {
      this.$store.commit("SetCompanySelect", companyId);
    },
    async handleSubmit() {
      this.$parent.isLoading = true;
      if (this.inputError.length > 0) {
        this.showErrors = true;
        setTimeout(() => {
          this.showErrors = false;
        }, 3000);
      } else {
        const payload = new FormData(document.getElementById("form-login"));
        this.isLoading = true;
        await this.authService.login(payload).then((response) => {
          // this.$parent.isLoading = false;
          if(response.success){
            this.$store.commit("AuthorityLogin", true);
            this.connectSocket();
            this.$store.commit("clearNotificationList");
            if (response.data.master) {
              this.authMasterUser(response.data);
            } else {
              this.authUser(response.data);
              this.$store.commit("SetCompanyList", response.data.meta.instituicoes_vinculadas);
              response.data.meta.instituicoes_vinculadas.map(object => {
                // if (object.principal) {
                //   this.setMainCompany(object.id);
                // } else{
                  this.setMainCompany(object.id);
                // }
              });
            }
          }else{
            this.$toast.error(response.message);
          }
          this.isLoading = false;
        })
      }
    }
  },
  validations: {
    user: {
      username: {
        or: or(alphaNum, email),
        required,
        minLength: minLength(6)
      },
      password: {
        required,
        minLength: minLength(3)
      }
    }
  }
};
</script>

<style>
.submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
